import { useMixpanelTracker } from "./useMixpanelTracker";

export const useContactFormMixpanelTracker = (
  selectorPrefix = "",
  deps = []
) => {
  useMixpanelTracker(
    "3",
    (mixpanel, formData) => {
      mixpanel.alias(formData["email"]);
      mixpanel.identify(formData["email"]);

      mixpanel.track("Contact form submission", {
        Name: formData["fullname"],
        Email: formData["email"],
        "Company name": formData["field[1]"],
        "Company website": formData["field[2]"],
        "How can we help you": formData["field[3]"],
        "How did you hear about us": formData["field[20]"]
      });

      mixpanel.people.set({
        $name: formData["fullname"],
        $email: formData["email"],
        "Company website": formData["field[2]"],
        "How did you hear about us": formData["field[20]"]
      });

      mixpanel.set_group("company", [formData["field[1]"]]);
      mixpanel.get_group("company", formData["field[1]"]).set({
        "Company website": formData["field[2]"],
        $name: formData["field[1]"]
      });
    },
    selectorPrefix,
    deps
  );
};
